import {
  OPEN_STUDENT_PLAN,
  CLEAR_STUDENT_PLAN,
  FETCH_STUDENT_PLAN,
  FETCH_STUDENT_PLAN_ERROR,
  FETCH_STUDENT_PLAN_SUCCESS,
  FETCH_STUDENT_PLANS,
  FETCH_STUDENT_PLANS_ERROR,
  FETCH_STUDENT_PLANS_SUCCESS,
  FETCH_STUDENT_PROGRESS,
  FETCH_STUDENT_PROGRESS_ERROR,
  FETCH_STUDENT_PROGRESS_SUCCESS,
} from './types';

const initialState = {
  studentUid: null,
  generation: 0,
  selectedPlanId: null,
  progressRequest: null,
  plansRequest: null,
  detailRequest: null,
  progress: null,
  progressLoading: false,
  progressError: false,
  plans: [],
  plansLoading: false,
  plansError: false,
  plan: null,
  planLoading: false,
};

const degreePlanningStudentPlanReducer = (state = initialState, action) => {
  if (action.generation !== undefined && (action.generation !== state.generation || action.studentUid !== state.studentUid)) return state;
  if (action.requestField && action.type !== action.startType && state[action.requestField] !== action.requestId) return state;
  switch (action.type) {
    case OPEN_STUDENT_PLAN:
      return { ...initialState, studentUid: action.studentUid, generation: state.generation + 1 };
    case FETCH_STUDENT_PROGRESS:
      return { ...state, progressRequest: action.requestId, progressLoading: true, progressError: false };
    case FETCH_STUDENT_PROGRESS_SUCCESS:
      return { ...state, progressLoading: false, progress: action.payload };
    case FETCH_STUDENT_PROGRESS_ERROR:
      return { ...state, progressLoading: false, progressError: true, progress: null };
    case FETCH_STUDENT_PLANS:
      return { ...state, plansRequest: action.requestId, plansLoading: true, plansError: false };
    case FETCH_STUDENT_PLANS_SUCCESS:
      return { ...state, plansLoading: false, plans: action.payload || [] };
    case FETCH_STUDENT_PLANS_ERROR:
      return { ...state, plansLoading: false, plansError: true, plans: [] };
    case FETCH_STUDENT_PLAN:
      return { ...state, selectedPlanId: action.planId, detailRequest: action.requestId, plan: null, planLoading: true };
    case FETCH_STUDENT_PLAN_SUCCESS:
      if (action.planId !== undefined && action.planId !== state.selectedPlanId) return state;
      return { ...state, planLoading: false, plan: action.payload };
    case FETCH_STUDENT_PLAN_ERROR:
      return { ...state, planLoading: false, plan: null };
    case CLEAR_STUDENT_PLAN:
      return { ...initialState, generation: state.generation + 1 };
    default:
      return state;
  }
};

export default degreePlanningStudentPlanReducer;
